// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1d4e0020","918":"810fed06"}[chunkId] + ".chunk.js";
};